module.exports = __webpack_public_path__ + "static/header-chevron-bg-ae02296fe06324f72f74e812c7ef1940.png";